import { Loader2 } from "lucide-react";
import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/use-auth";

export function AuthGuard({ children }: PropsWithChildren) {
  const { isApproved, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Loader2 className="size-4 animate-spin motion-reduce:animate-none" />
          Checking session…
        </div>
      </div>
    );
  }

  if (!user) {
    const redirect = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate replace state={{ from: redirect }} to="/login" />;
  }

  if (!isApproved) {
    const redirect = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate replace state={{ from: redirect, reason: "approval_pending" }} to="/login" />;
  }

  return <>{children}</>;
}
